import type { DealStatusDealerFeeEntry } from "@credit-acceptance/step6-bff-client";
import { useTranslation } from "react-i18next";

import { formatSignedCurrency } from "../../../../lib/money";
import type { AuditTableColumn } from "../../../audit/AuditTable";
import SummaryTableModal from "../../components/SummaryTableModal";

interface DealFeesModalProperties {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  fees: DealStatusDealerFeeEntry[];
  total: number;
}

const amountFormatter = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Breakdown of the Deal Fees deduction, opened from the "Deal Fees" link in DealStatus
function DealFeesModal({ open, onOpenChange, fees, total }: DealFeesModalProperties) {
  const { t } = useTranslation();

  const columns: Array<AuditTableColumn<DealStatusDealerFeeEntry>> = [
    { key: "name", header: t("dealStatus.dealFeesModal.feeName"), render: (fee) => fee.feeName ?? "—" },
    {
      key: "amount",
      header: t("dealStatus.dealFeesModal.amount"),
      render: (fee) => amountFormatter.format(fee.feeAmount ?? 0),
    },
  ];

  return (
    <SummaryTableModal
      open={open}
      onOpenChange={onOpenChange}
      title={t("dealStatus.dealFeesModal.title")}
      description={t("dealStatus.dealFeesModal.description")}
      caption={t("dealStatus.dealFeesModal.caption")}
      summaryLines={[{ label: t("dealStatus.dealFeesModal.title"), value: formatSignedCurrency(total) }]}
      columns={columns}
      rows={fees}
    />
  );
}

export default DealFeesModal;
